import { useMemo } from 'preact/hooks'
import { useLocation } from 'wouter-preact'

export interface QueryParams {
  [key: string]: string | undefined
}

export function useQueryParams(): QueryParams {
  const [location] = useLocation()

  return useMemo(() => {
    // Parse query string from current location
    const searchParams = new URLSearchParams(window.location.search)
    const params: QueryParams = {}

    // Convert URLSearchParams to plain object
    for (const [key, value] of searchParams.entries()) {
      params[key] = value
    }

    return params
  }, [location]) // Re-calculate when location changes
}

export function useQueryParam(key: string): string | undefined {
  const params = useQueryParams()
  return params[key]
}
